import { render, staticRenderFns } from "./imgzo_copyright.vue?vue&type=template&id=661ab459"
import script from "./imgzo_copyright.vue?vue&type=script&lang=js"
export * from "./imgzo_copyright.vue?vue&type=script&lang=js"
import style0 from "./imgzo_copyright.vue?vue&type=style&index=0&id=661ab459&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports